// Integrated controller for font purchasing form with variant selection
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["allCheckbox", "variantCheckbox"];

    connect() {
        this.toggleVariant(); // 최초 설정값 적용 및 submit 처리 1회 해주기
    }

    // Form submission - inherited from components/form_controller
    submit(_e) {
        this.element.requestSubmit();
    }

    // Toggle all variants when "select all" checkbox is clicked
    toggleAll() {
        const isAllSelected = this.allCheckboxTarget.checked;

        this.variantCheckboxTargets.forEach(checkbox => {
            checkbox.checked = isAllSelected;
        });

        this.submit();
    }

    // Handle individual variant checkbox changes
    toggleVariant() {
        this.updateAllCheckboxState();
        this.submit();
    }

    // Update the "select all" checkbox state based on individual selections
    updateAllCheckboxState() {
        if (!this.hasAllCheckboxTarget) return;

        const totalVariants = this.variantCheckboxTargets.length;
        const checkedVariants = this.variantCheckboxTargets.filter(cb => cb.checked).length;

        this.allCheckboxTarget.checked = (checkedVariants === totalVariants && totalVariants > 0);
    }
}